import {
    LOAD_ACTIVITY_TYPES,
    ADD_ACTIVITY_TYPE,
    ERROR,
    SYNCHRO_GET_API_ACTIVITY_TYPES,
    IS_LOADING,
    DRIVING_ACTIVITY_TYPE_CODE,
    WORK_ORDER_ACTIVITY_TYPE_CODE,
} from "./activityTypesConstants";
import db from "../../db";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";

export function createActivityType(activityType) {
    activityType.home = activityType.end_of_day;
    activityType.intervention = activityType.work_order_activity;
    activityType.has_business = activityType.analytic_required;
    return activityType;
}

export function addActivityType(activity) {
    return (dispatch) => {
        db.ActivityType.put(activity)
            .then(() => {
                dispatch({ type: ADD_ACTIVITY_TYPE, payload: activity });
            })
            .catch((err) => {
                console.error("Erreur : activityTypesActions - addActivityType");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de l'ajout d'un type d'activité !",
                    })
                );
                dispatch({ type: ERROR, info: "addActivityType", error: err });
            });
    };
}

export function getDriving(callback) {
    db.transaction("r?", db.ActivityType, async () => {
        db.ActivityType.each((data) => {
            if (data.code === DRIVING_ACTIVITY_TYPE_CODE) {
                callback(data);
                return;
            }
        });
    }).catch((e) => {
        console.error("Erreur : activityTypesActions - getDriving");
        throw e;
    });
}

export function getInterventionType() {
    return db.transaction("r?", db.ActivityType, () => {
        return db.ActivityType.toArray().then((data) => {
            return data.find((type) => type.code === WORK_ORDER_ACTIVITY_TYPE_CODE);
        });
    });
}

export async function getActivityTypeById(id) {
    return await db.ActivityType.where("id")
        .equals(id)
        .first(async (data) => {
            return data;
        })
        .catch((e) => {
            console.error("Erreur : activityTypesActions - getActivityTypeById");
            throw e;
        });
}

export function getAllActivityTypes() {
    return (dispatch) => {
        db.ActivityType.toArray((coll) => {
            coll.sort(function (a, b) {
                if (a.sequence < b.sequence) return -1;
                if (a.sequence > b.sequence) return 1;
                return 0;
            });
            dispatch({ type: LOAD_ACTIVITY_TYPES, activityTypes: coll });
        }).catch((e) => {
            console.error("Erreur : activityTypesActions - getAllActivityTypes");
            throw e;
        });
    };
}

export function refreshActivitiesInDb(activityTypes) {
    return (dispatch) => {
        db.transaction("rw!", db.ActivityType, async () => {
            db.ActivityType.toCollection()
                .delete()
                .then(() => {
                    for (let i = 0; i < activityTypes.length; i++) {
                        let at = createActivityType(activityTypes[i]);
                        dispatch(addActivityType(at));
                    }
                })
                .catch((err) => {
                    console.error("Erreur : activityTypesActions - refreshActivitiesInDb");

                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors du rafraichissement des types d'activités !",
                        })
                    );
                    dispatch({ type: ERROR, info: "Suppression de tous les types d'activité", error: err });
                });
        }).catch((err) => {
            console.error("Erreur : activityTypesActions - refreshActivitiesInDb");
            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors du rafraichissement des types d'activités !",
                })
            );
            dispatch({ type: ERROR, info: "Récupération de synchronisation", error: err });
        });
    };
}

export function activityTypesHasErrored(error) {
    return {
        type: ERROR,
        info: "Récupération des types d'activité",
        error: error,
    };
}

export function activityTypesIsLoading(bool) {
    return {
        type: IS_LOADING,
        info: "Récupération des types d'activité",
        isLoading: bool,
    };
}

export function activityTypesFetchDataSuccess(activityTypes) {
    return {
        type: SYNCHRO_GET_API_ACTIVITY_TYPES,
        payload: activityTypes,
    };
}

export function activityTypesFetchData(discreet) {
    return (dispatch) => {
        if (!discreet) dispatch(activityTypesIsLoading(true));

        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v2/weekly_report_activity_type/all/" + false + "/" + true, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(activityTypesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((activityTypes) => {
                dispatch(activityTypesFetchDataSuccess(activityTypes));

                if (activityTypes.length > 0) {
                    dispatch(refreshActivitiesInDb(activityTypes));
                }
            })
            .catch((err) => {
                console.error("Erreur : activityTypesActions - activityTypesFetchData", err);
                if (!discreet) {
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des types d'activités !",
                        })
                    );

                    dispatch(activityTypesIsLoading(false));
                }
            });
    };
}
